<template>
  <div class="content-4">
    <div class="title">情绪小贴士</div>
    <div class="r-list">
      <div
        class="r-item"
        v-for="(item, index) in info.emotionTips"
        :key="index"
      >
        <div class="d-title" v-if="item.title != '意志力'">
          <div class="d-text">{{ item.title }}</div>
        </div>
        <div class="d-title-require" v-else>{{ item.title }}</div>
        <div class="r-text" v-html="item.content"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.content-4 {
  box-sizing: border-box;
  width: 335px;
  margin: 0 auto 20px;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;

  .title {
    position: relative;
    z-index: 1;
    display: inline-block;
    font-size: 22px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 28px;
    height: 28px;
    margin-bottom: 22px;
  }

  .title::after {
    position: absolute;
    z-index: -1;
    left: 0;
    bottom: 0;
    content: '';
    width: 100%;
    height: 7px;
    background: linear-gradient(
      270deg,
      rgba(190, 182, 254, 0) 0%,
      #897ffc 100%
    );
    opacity: 0.7;
  }

  .d-title {
    text-align: center;
    margin-bottom: 16px;
    .d-text {
      margin: 0 auto;
      position: relative;
      display: inline-block;
      font-size: 22px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: 600;
      color: #6759ff;
      line-height: 21px;
    }

    .d-text::before {
      content: '';
      position: absolute;
      right: calc(100% + 16px);
      top: 50%;
      width: 31px;
      height: 1px;
      background-color: #ddd;
    }

    .d-text::after {
      content: '';
      position: absolute;
      left: calc(100% + 16px);
      top: 50%;
      width: 31px;
      height: 1px;
      background-color: #ddd;
    }
  }

  .d-title-require {
    margin-bottom: 16px;
    font-size: 15px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 21px;
  }

  .r-list {
    text-align: left;

    .r-item {
      margin-bottom: 20px;
      padding: 20px 16px;
      background: #f4f6fa;
      border-radius: 12px;

      .r-title {
        position: relative;
        text-indent: 10px;
        font-size: 15px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 21px;
        margin-bottom: 16px;
      }

      .r-title::after {
        content: '';
        left: 0;
        top: 50%;
        transform: translate(0%, -50%);
        position: absolute;
        width: 3px;
        height: 14px;
        background: #9288fd;
      }

      .r-text {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        line-height: 20px;
      }
    }

    .r-item:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
